import EmojiPicker from 'vue3-emoji-picker'

export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.component('EmojiPicker', EmojiPicker, {})
})
